export default __webpack_public_path__ + "static/media/mslg.29d79fa5.svg";